export const PersonalCareFormFamily = {
  title: 'Personal care',
  formVersion: 1,
  description: 'Client Personal Care Intake Form',
  formKey: 'CLIENT_PERSONAL_CARE_INTAKE_FORM',
  questions: {
    'PersonalCare-tasks': {
      questionId: 'PersonalCare-tasks',
      fieldType: 'checkbox',
      rank: 1,
      questionData: {
        label: 'What types of personal care do they need help with?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'bathing', label: 'Bathing or showering', isOther: false},
        {value: 'dressing', label: 'Dressing (morning or bedtime)', isOther: false},
        {value: 'toileting', label: 'Toileting', isOther: false},
        {value: 'hygiene', label: 'Hygiene (brushing teeth, grooming, skincare)', isOther: false},
        {value: 'incontinence-care', label: 'Incontinence care', isOther: false},
        {value: 'changing-clothes', label: 'Changing clothes after accidents', isOther: false},
        {value: 'washing-hair', label: 'Washing hair', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
    'PersonalCare-equipment': {
      questionId: 'PersonalCare-equipment',
      fieldType: 'checkbox',
      rank: 2,
      questionData: {
        label: 'Do they use any personal care equipment?',
        helpText: '',
        required: false,
      },
      options: [
        {value: 'shower-chair', label: 'Shower chair', isOther: false},
        {value: 'grab-bars', label: 'Grab bars', isOther: false},
        {value: 'commode', label: 'Commode', isOther: false},
        {value: 'incontinence-products', label: 'Incontinence products (briefs, pads)', isOther: false},
        {value: 'slide-board', label: 'Slide board or transfer aids', isOther: false},
        {value: 'handheld-shower', label: 'Handheld shower', isOther: false},
        {value: 'bath-lift', label: 'Bath lift', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
    'PersonalCare-assistance-level': {
      questionId: 'PersonalCare-assistance-level',
      fieldType: 'radio',
      rank: 3,
      questionData: {
        label: 'What level of assistance is needed?',
        helpText: '',
        required: true,
      },
      options: [
        {value: 'supervision', label: 'Supervision only', isOther: false},
        {value: 'light', label: 'Light hands-on support', isOther: false},
        {value: 'moderate', label: 'Moderate support', isOther: false},
        {value: 'full', label: 'Full support', isOther: false},
        {value: 'other', label: 'Other', isOther: true},
      ],
    },
  },
};
